import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useFeatureFlags } from "./FeatureFlagsContext";
/**
 * An HOC for using feature flags in class components.
 * If the component has a prop with the same name as a feature flag, the prop will override
 * the feature flag.
 */
export function withFeatureFlags(Component) {
  const WrappedComponent = props => {
    const featureFlags = useFeatureFlags();
    return /*#__PURE__*/React.createElement(Component, _extends({}, featureFlags, props));
  };
  WrappedComponent.displayName = "withFeatureFlags(".concat(Component.displayName, ")");
  return WrappedComponent;
}